import { useEffect, useState } from 'react';

const PRESETS = {
  categories: [
    { maxWidth: 480, slides: 2 },
    { maxWidth: 640, slides: 2 },
    { maxWidth: 768, slides: 3 },
    { maxWidth: 1024, slides: 4 },
    { maxWidth: 1200, slides: 4 },
    { maxWidth: Infinity, slides: 5 },
  ],
  products: [
    { maxWidth: 480, slides: 1 },
    { maxWidth: 640, slides: 2 },
    { maxWidth: 768, slides: 2 },
    { maxWidth: 1024, slides: 3 },
    { maxWidth: 1200, slides: 3 },
    { maxWidth: Infinity, slides: 4 },
  ],
  reviews: [
    { maxWidth: 640, slides: 1 },
    { maxWidth: 1024, slides: 1 },
    { maxWidth: Infinity, slides: 2 },
  ],
};

export const resolveSlidesToShow = (width, preset = 'categories', count = Infinity) => {
  const breakpoints = PRESETS[preset] || PRESETS.categories;

  for (const { maxWidth, slides } of breakpoints) {
    if (width <= maxWidth) {
      return Math.min(slides, count);
    }
  }

  return Math.min(4, count);
};

const useSlidesToShow = (count, preset = 'categories') => {
  const [slidesToShow, setSlidesToShow] = useState(() => {
    if (typeof window === 'undefined') {
      return Math.min(4, count) || 1;
    }
    return resolveSlidesToShow(window.innerWidth, preset, count) || 1;
  });

  useEffect(() => {
    const update = () => {
      const next = resolveSlidesToShow(window.innerWidth, preset, count) || 1;
      setSlidesToShow(next);
    };

    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, [count, preset]);

  return slidesToShow;
};

export default useSlidesToShow;
